import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	UnlikePetitionSupporterComment,
	type UnlikePetitionSupporterCommentMutation,
	type UnlikePetitionSupporterCommentMutationVariables,
} from './unlikeSupporterComment.graphql';

export async function unlikeSupporterComment(commentId: string, { gql: { fetch } }: UtilityContext): Promise<void> {
	const { data } = await fetch<UnlikePetitionSupporterCommentMutation, UnlikePetitionSupporterCommentMutationVariables>(
		{
			query: UnlikePetitionSupporterComment,
			variables: { commentId },
			rejectOnError: true,
			batched: false,
		},
	);

	if (!data.unlikePetitionSupporterComment.success) {
		throw new Error('Unlike failed');
	}
}
